import { toast } from "@inno-ui/toast";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { declineSmartSchedulingAvailability } from "../../api/smart-scheduling/decline-smart-scheduling-availability";

export function useDeclineSmartSchedulingSlots() {
  const { t } = useTranslation();
  const { userToken } = useParams();

  if (!userToken) {
    toast.error({ title: t("User token is required") });
    return;
  }

  return useMutation({
    mutationFn: () => declineSmartSchedulingAvailability(userToken),
    onError: (error) => {
      return error;
    },
  });
}
